import { getKeys } from './getKeys'

export const cernerTranslations = {
  PERMISSION_REQUIRED: 'Permission Required',
  PERMISSION_DESCRIPTION:
    'You do not have permission to view Shared Care Records. Please speak to your system administrator.',
  INSUFFICIENT_CERNER_ROLE_DESCRIPTION:
    'You do not have the required permissions to access the London Care Record. Please speak to your Admin.',
  SITE_CONFIGURATION_REQUIRED: 'Site Configuration Required',
  SITE_CONFIGURATION_DESCRIPTION:
    'This site is not configured for Shared Care Record access. Please contact your administrator.',
  INACTIVE_SERVICE_USER: 'Inactive Service User',
  INACTIVE_SERVICE_USER_DESCRIPTION:
    'This service user is inactive. Their health record cannot be accessed.',
  NHS_NUMBER_REQUIRED: 'NHS Number Required',
  COLLAPSE: 'Collapse',
  EXPAND: 'Expand',
  NHS_NUMBER_DESCRIPTION:
    'This service user does not have an NHS number. Please update their profile before accessing their health record.',
  ACCESS_CONFIRMATION_TITLE: 'Access confirmation',
  ACCESS_CONFIRMATION_MESSAGE:
    'You are about to access the London Care Record for this person.\n\nBecause these are sensitive records, your access will be logged and may be audited by the NHS or authorised partners. Only approved NHS roles may use the London Care Record.\n\nBy continuing, you confirm that:',
  ACCESS_CONFIRMATION_POINT_1:
    'You have permission to view this record under NHS rules.',
  ACCESS_CONFIRMATION_POINT_2:
    'You will use and share the information only in line with law and NHS guidance.',
  ACCESS_CONFIRMATION_POINT_3:
    'Your login is personal to you and will not be shared.',
  ACCESS_CONFIRMATION_POINT_4: 'You have completed the required training.',
  CONFIRM: 'Confirm',
}

export const cernerConstants = getKeys(cernerTranslations)
